import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './liquid-glass.css'
import './landing.css'
import './core-pages.css'
import './themes.css'
import './studio.css'
import App from './App.jsx'
import FeedbackToaster from './components/ui/FeedbackToaster.jsx'

import { initWasm } from './lib/wasmLoader.js';
import { registerServiceWorker } from './lib/registerServiceWorker.js';
import { installDpopFetchInterceptor } from './lib/dpop.js';

// Render the app first, then bootstrap non-critical services after first paint
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <FeedbackToaster />
    <App />
  </StrictMode>,
)

// Defer heavy bootstrapping so it doesn't block initial render
const deferBoot = typeof requestIdleCallback === 'function' ? requestIdleCallback : (fn) => setTimeout(fn, 100);
deferBoot(() => {
  initWasm();
  registerServiceWorker();
  installDpopFetchInterceptor();
});

